import TableLayout from './TableLayout.vue'

export default TableLayout
